import {Injectable} from '@angular/core';

const ACCESS_TOKEN_KEY = 'access_token';

@Injectable({providedIn: 'root'})
export class TokenStorage{
    getAccessToken():string | null{
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    setAccessToken(token: string): void {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
    }

    clear(): void {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
}